const dataObject = {
  consignor_name: "",
  consignor_id: "",
  station_to: "",
  station_to_name: "",
  rate_info: [],
  created_from: "",
  created_by: "",
  consignee_name: "",
  consignee: "",
  consignee_gst: "",
  consignee_fetch: 0,
};

function validate(values) {
  let errors = {};
  return errors;
}

const consigneeStationTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Consignor Name", className: "text-center table-header" },
  { label: "Consignee Name", className: "text-center table-header" },
  { label: "Consignee GST", className: "text-center table-header" },
  { label: "Station To", className: "text-center table-header" },
];

const consigneeStationTableItems = [
  {
    type: "text",
    name: "consignor_name",
    label: "Consignor Name",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "consignee_name",
    label: "Consignee name",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "consignee_gst",
    label: "Consignee GST",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "station_to_name",
    label: "Station To",
    className: "form-control-large-col",
  },
];

const popupInfo = {
  error_header: "Error In Consignee Station Module ",
  success_header: "Consignee Station Saving Successful ",
  success_title: "Consignee Station is successfully created",
  field_label_success: "",
  field_name_success: "",
  error_title: "Error in Consignee Station module with the following info:-",
  field_label_error: "Error:",
};

export {
  consigneeStationTableHeader,
  consigneeStationTableItems,
  dataObject,
  validate,
  popupInfo,
};
